<template>
  <div>
    <wc-data-box
      :title='header.title'
      :titleIcon='header.icon'
      :titleIconColor='header.iconColor'
      showEdit
      @edit='editClient'
    >
      <wc-two-column-table :items='basics'></wc-two-column-table>
    </wc-data-box>

    <wc-dialog
      :showDialog='showDialog'
      :title='header.title'
      :icon='header.icon'
      :iconColor='header.color'
      :disableButtons='!isFormValid'
      @cancel='showDialog = false'
      @save='save'
    >
      <v-form v-model='isFormValid' ref='form'>
        <details-form v-model='clientCopy'></details-form>
      </v-form>
      <template v-slot:dialog-actions>
        <v-btn v-if='!isFormValid' class='primary--text' small text @click='validateForm'>Why can't I save?</v-btn>
      </template>
    </wc-dialog>
  </div>
</template>

<script>
import _ from 'lodash'
import { mapState } from 'vuex'
import DetailsForm from '@/modules/clients/components/forms/DetailsForm'

export default {
  name: 'client-details',
  props: {
    client: {
      required: true
    }
  },
  data: () => ({
    isLoading: false,
    isFormValid: false,
    clientCopy: {},
    showDialog: false
  }),
  computed: {
    ...mapState({
      header: state => state.icons.dataBox.address
    }),
    basics () {
      let table = [
        { text: 'Address', value: this.client.address },
        { text: 'City', value: this.client.city },
        { text: 'Postal Code', value: this.client.postal },
        { text: 'Province', value: this.client.province },
        { text: 'Country', value: this.client.country }
      ]
      return table
    }
  },
  methods: {
    editClient () {
      this.clientCopy = _.cloneDeep(this.client)
      this.showDialog = true
    },
    save () {
      this.$emit('update', this.clientCopy)
      this.showDialog = false
    },
    validateForm() {
      this.$nextTick(() => {
        this.$refs.form.validate()
      })
    }
  },
  components: {
    'details-form': DetailsForm
  }
}
</script>
